module.exports = __webpack_public_path__ + "img/optimization.823893c1.png";